import './style.scss';
import {
  SymbolDetailInfo,
  OverseasRealEstateSymbolDetailInfo,
} from 'views/utils/graphql/graphql';
import { SimpleTooltip } from 'views/mutual/tooltip';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';

export type LeaseFundBasicInfoProps = {
  isFull: boolean;
} & SymbolDetailInfo;

export const LeaseFundBasicInfo = ({
  isFull,
  SymbolName,
  SymbolShortName,
  SymbolType,
  TenantSummary,
  TenantName,
}: LeaseFundBasicInfoProps) => {
  return (
    <div className="leaseFund">
      <div className="basicInfo">
        <div className={`basicInfo_title ${isFull ? 'fullTitle' : ''}`}>{`${
          isFull ? SymbolName : SymbolShortName
        }（${SymbolType}）`}</div>
        {/* <div className={`basicInfo_field ${isFull ? 'fullField' : ''}`}>
        {`この案件は、${PaLDistMonth.map(m => m.replace(/\d{1,2}日/g, '')).join(
          '、又は、',
        )}決算法人様を対象としております。決算月の異なる法人様につきましては、基本的に、お申し込みをお断りしておりますので、ご了承ください。`}
      </div> */}
        <div className="basicInfo_tenant">
          <TenantTag />
          <SimpleTooltip triggerText={TenantName} description={TenantSummary ?? ''} />
        </div>
      </div>
    </div>
  );
};

const TenantTag = () => {
  return (
    <div className="tenantTag">
      <span className="tenantTag_label">賃借人等</span>
      <span className="tenantTag_description">※1</span>
    </div>
  );
};

export type DomesticRealEstateBasicInfoProps = {
  isFull: boolean;
} & DomesticRealEstateSymbolDetailInfo;

export const DomesticRealEstateBasicInfo = ({
  isFull,
  ProductName,
  OriginalContractBuildingName,
}: DomesticRealEstateBasicInfoProps) => {
  return (
    <div className="domesticRealEstate">
      <div className="basicInfo">
        <div className={`basicInfo_title ${isFull ? 'fullTitle' : ''}`}>{`${
          isFull ? ProductName : OriginalContractBuildingName
        }`}</div>
        {/* <div className={`basicInfo_field ${isFull ? 'fullField' : ''}`}>
        {`この案件は、${PaLDistMonth.map(m => m.replace(/\d{1,2}日/g, '')).join(
          '、又は、',
        )}決算法人様を対象としております。決算月の異なる法人様につきましては、基本的に、お申し込みをお断りしておりますので、ご了承ください。`}
      </div> */}
      </div>
    </div>
  );
};

export type OverseasRealEstateBasicInfoProps = {
  isFull: boolean;
} & OverseasRealEstateSymbolDetailInfo;

export const OverseasRealEstateBasicInfo = ({
  isFull,
  SymbolName,
  SymbolShortName,
}: OverseasRealEstateBasicInfoProps) => {
  return (
    <div className="overseasRealEstate">
      <div className="basicInfo">
        <div className={`basicInfo_title ${isFull ? 'fullTitle' : ''}`}>{`${
          isFull ? SymbolName : SymbolShortName
        }`}</div>
        {/* <div className={`basicInfo_field ${isFull ? 'fullField' : ''}`}>
        {`この案件は、${PaLDistMonth.map(m => m.replace(/\d{1,2}日/g, '')).join(
          '、又は、',
        )}決算法人様を対象としております。決算月の異なる法人様につきましては、基本的に、お申し込みをお断りしておりますので、ご了承ください。`}
      </div> */}
      </div>
    </div>
  );
};
